export default __webpack_public_path__ + "static/media/I0007.34e58201.png";